"use client";
import React, { useState } from "react";
import {
  Search,
  Trash2,
  Pencil,
  CheckCircle,
  XCircle,
  Info,
} from "lucide-react";
export default function BlogComment() {
  const [search, setSearch] = useState({
    from: "",
    to: "",
    approved: "All",
    message: "",
  });
  const [comments, setComments] = useState([
    {
      id: 1,
      blogPost: "How a blog can help your growing e-Commerce business",
      customer: "admin@yourStore.com",
      comment: "This is a sample comment for this blog post",
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
    {
      id: 2,
      blogPost: "Why your online store needs a wish list",
      customer: "admin@yourStore.com",
      comment: "This is a sample comment for this blog post",
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
  ]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openDialog, setOpenDialog] = useState(null); // approve | disapprove | delete
  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };
  const filtered = comments.filter((c) =>
    c.comment.toLowerCase().includes(search.message.toLowerCase())
  );
  // 🔹 Confirm dialog actions
  const handleDialogAction = () => {
    if (openDialog === "Delete selected") {
      // remove permanently
      setComments((prev) => prev.filter((c) => !selectedIds.includes(c.id)));
      setSelectedIds([]);
    }
    setOpenDialog(null);
  };
  // 🔹 Delete individual comment
  const handleDeleteSingle = (id) => {
    if (window.confirm("Are you sure you want to permanently delete this comment?")) {
      setComments((prev) => prev.filter((c) => c.id !== id));
      setSelectedIds((prev) => prev.filter((i) => i !== id));
    }
  };
  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-2xl font-semibold text-gray-800 mb-4">
        Blog comments
      </h1>
      {/* Top Action Buttons */}
      <div className="flex flex-wrap gap-2 mb-4">
        <button
          onClick={() => setOpenDialog("Approve selected")}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm"
        >
          <CheckCircle size={16} />
          Approve selected
        </button>
        <button
          onClick={() => setOpenDialog("Disapprove selected")}
          className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg text-sm"
        >
          <XCircle size={16} />
          Disapprove selected
        </button>
        <button
          onClick={() => setOpenDialog("Delete selected")}
          disabled={selectedIds.length === 0}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm ${
            selectedIds.length === 0
              ? "bg-red-300 cursor-not-allowed text-white"
              : "bg-red-600 hover:bg-red-700 text-white"
          }`}
        >
          <Trash2 size={16} />
          Delete selected
        </button>
      </div>
      {/* Search Filters */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
              Created from <Info size={14} className="text-gray-400" />
            </label>
            <input
              type="date"
              value={search.from}
              onChange={(e) =>
                setSearch((prev) => ({ ...prev, from: e.target.value }))
              }
              className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
              Created to <Info size={14} className="text-gray-400" />
            </label>
            <input
              type="date"
              value={search.to}
              onChange={(e) =>
                setSearch((prev) => ({ ...prev, to: e.target.value }))
              }
              className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
              Approved <Info size={14} className="text-gray-400" />
            </label>
            <select
              value={search.approved}
              onChange={(e) =>
                setSearch((prev) => ({ ...prev, approved: e.target.value }))
              }
              className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            >
              <option>All</option>
              <option>Approved</option>
              <option>Disapproved</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
              Message <Info size={14} className="text-gray-400" />
            </label>
            <input
              type="text"
              placeholder="Search message..."
              value={search.message}
              onChange={(e) =>
                setSearch((prev) => ({ ...prev, message: e.target.value }))
              }
              className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="mt-4">
          <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm">
            <Search size={16} />
            Search
          </button>
        </div>
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-sm">
              <th className="px-4 py-3 border-b"></th>
              <th className="text-left px-4 py-3 border-b">Blog post</th>
              <th className="text-left px-4 py-3 border-b">Customer</th>
              <th className="text-left px-4 py-3 border-b">Comment</th>
              <th className="text-left px-4 py-3 border-b">Is approved</th>
              <th className="text-left px-4 py-3 border-b">Created on</th>
              <th className="text-left px-4 py-3 border-b">Edit</th>
              <th className="text-left px-4 py-3 border-b">Delete</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((item) => (
              <tr
                key={item.id}
                className="text-gray-800 text-sm hover:bg-gray-50 border-b"
              >
                <td className="px-4 py-3">
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(item.id)}
                    onChange={() => toggleSelect(item.id)}
                  />
                </td>
                <td className="px-4 py-3">{item.blogPost}</td>
                <td className="px-4 py-3">{item.customer}</td>
                <td className="px-4 py-3">{item.comment}</td>
                <td className="px-4 py-3">
                  {item.approved && (
                    <CheckCircle size={16} className="text-blue-600" />
                  )}
                </td>
                <td className="px-4 py-3">{item.createdOn}</td>
                <td className="px-4 py-3">
                  <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-lg text-gray-700">
                    <Pencil size={14} /> Edit
                  </button>
                </td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => handleDeleteSingle(item.id)}
                    className="flex items-center gap-1 bg-red-100 hover:bg-red-200 px-3 py-1 rounded-lg text-red-700"
                  >
                    <Trash2 size={14} /> Delete
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td
                  colSpan={8}
                  className="text-center text-gray-500 py-6 text-sm"
                >
                  No comments found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Dialog */}
      {openDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 sm:w-96">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              {openDialog}
            </h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to {openDialog.toLowerCase()}{" "}
              {selectedIds.length} selected item(s)?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setOpenDialog(null)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleDialogAction}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
